// src/content/privacyContent.js
const privacyContent = [
    {
      title: "1. Data Protection Commitment",
      text: "Propertunity is committed to protecting your privacy. We do not sell, trade, or share your personal data with third parties...",
    },
    {
      title: "2. Data Collection & Usage",
      text: "We collect only the necessary data to provide our services. We do not use Google Analytics...",
    },
    {
      title: "3. Legal Basis for Processing",
      text: "We process personal data based on:",
      list: [
        "Contractual necessity (e.g., processing payments)",
        "Legitimate interest (e.g., service improvement)",
        "Legal obligations (e.g., compliance with financial regulations)",
      ],
    },
    {
      title: "4. Data Subject Rights (GDPR)",
      text: "As per the General Data Protection Regulation (GDPR), users in the EU have the right to:",
      list: [
        "Access their personal data",
        "Request correction or deletion",
        "Object to processing in certain cases",
        "Request data portability",
      ],
    },
    {
      title: "5. Data Security",
      text: "We implement strong security measures to protect your information...",
    },
    {
      title: "6. Third-Party Services",
      text: "We share data only with service providers essential for our operations (e.g., Stripe)...",
    },
    {
      title: "7. Updates to This Policy",
      text: "We may update this policy periodically. Any significant changes will be communicated to users.",
    },
  ];
  
  export default privacyContent;
  